export default {"src":"/_next/static/media/callout-success.e8ac3824.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};